import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Bottom from './Bottom';

@inject('commonStore', 'menuStore', 'orderStore')
@observer
class PaymentPayStory extends Component {
  returnUrl = `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/pay-story`;

  constructor(props) {
    super(props);

    window.pay_result_submit = this.pay_result_submit.bind(this);
  }

  componentDidMount() {
    this.props.orderStore.setPaymentMethod('1');

    // PG사 외부 스크립트 include
    const script = document.createElement('script');
    script.src = '/pgAsistant.js';
    script.async = false;
    document.body.appendChild(script);
  }

  // 결제방법 변경
  handlePayMethodChange = event => {
    this.props.orderStore.setPaymentMethod(event.target.value);
  };

  pay = async () => {
    /* global SendPay */
    SendPay(document.payInit);
  };

  pay_result_submit() {
    /* global payResultSubmit */
    payResultSubmit();
  }

  render() {
    const { t, menuStore, orderStore } = this.props;
    return (
      <React.Fragment>
        {/* 결제방법 선택 */}
        {menuStore.storeData.isEzwelPayUsed && (
          <Grid item container direction={'column'} spacing={1} style={{ marginTop: '25px' }}>
            <Grid item>
              <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>{t('payment.label.method')}</span>
            </Grid>
            <Grid item>
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={orderStore.paymentMethod}
                onChange={this.handlePayMethodChange}
              >
                <FormControlLabel value={1} control={<Radio color="primary" />} label={'일반결제'} />
                <FormControlLabel value={0} control={<Radio color="primary" />} label={'이지웰페이'} />
              </RadioGroup>
            </Grid>
          </Grid>
        )}

        <form name="payInit" method="post" action={this.returnUrl}>
          {/************************* 공통 필수 *************************/}
          {/* 상점아이디 */}
          <input type="hidden" name="mid" value={menuStore.storeData ? menuStore.storeData.merchantID : ''} />
          {/* USE escrow false(0)/true(1) */}
          <input type="hidden" name="trxCd" value="0" />
          {/* 상품명 */}
          <input type="hidden" name="goodsNm" value={orderStore.paymentMenuName} />
          {/* 주문번호 */}
          {orderStore.orderAuthData && <input type="hidden" name="ordNo" value={orderStore.orderAuthData.orderId} />}
          {/* 금액 */}
          <input type="hidden" name="goodsAmt" value={orderStore.paymentAmount} />
          {/* 구매장 이름 */}
          <input type="hidden" name="ordNm" value="IMU" />
          {/* 구매자 연락처 */}
          <input type="hidden" name="ordTel" value={orderStore.orderData.userId} />
          {/* 요청시간 (YYYYMMDDHHMISS) */}
          {orderStore.orderAuthData && (
            <input
              type="hidden"
              name="ediDate"
              value={`${orderStore.orderAuthData.ediDate}${orderStore.orderAuthData.ediTime}`}
            />
          )}
          {/* 위변조 검증 해쉬값 */}
          {orderStore.orderAuthData && <input type="hidden" name="encData" value={orderStore.orderAuthData.signData} />}

          {/************************* 모바일 필수 *************************/}
          {/* 요청 응답 URL */}
          <input type="hidden" name="returnUrl" value={this.returnUrl} />

          {/************************* 옵션 *************************/}
          {/* 결제타입, 콤마 구분자로 다중값 사용 가능 (CARD, BANK, VBANK, CELLPHONE) */}
          <input type="hidden" name="payMethod" value="CARD" />
          {/* 표시할 카드사 (01-02-...) */}
          <input type="hidden" name="cardCd" value="" />
          {/* 간편결제 표시 (02: 카카오페이, 03: 페이코, 05: 네이버페이) */}
          <input type="hidden" name="easyPayYN" value="" />
          {/* 상점 부담 무이자설정 (01-02) */}
          <input type="hidden" name="noIntMonth" value="" />
          {/* 구매자 이메일 */}
          <input type="hidden" name="ordEmail" value="" />
          {/* 구매자 아이피 */}
          <input type="hidden" name="userIp" value="" />
          {/* 상점 고객ID */}
          <input type="hidden" name="mbsUsrId" value="" />
          {/* 상점 정의 필드 */}
          <input
            type="hidden"
            name="mbsReserved"
            value={`${menuStore.storeData.companyId}|${menuStore.storeData.storeCode}|${orderStore.isLiteOrder}`}
          />
          {/* 공급가액 (별도 설정 시 사용) */}
          <input type="hidden" name="goodsSplAmt" value={orderStore.orderData.paymentTaxable} />
          {/* 부가세 (별도 설정 시 사용) */}
          <input type="hidden" name="goodsVat" value={orderStore.orderData.paymentTax} />
          {/* 봉사료 (별도 설정 시 사용) */}
          <input type="hidden" name="goodsSvsAmt" value="0" />
          {/* Noti 수신 URL (가상계좌 사용 시 필수) */}
          <input type="hidden" name="notiUrl" value="" />
          {/* 결제창 언어 (KOR, ENG) */}
          <input type="hidden" name="language" value="KOR" />
          {/* IOS 에서 ISP 인증 완료후 이동될 가맹점 APP의 scheme 이름 */}
          <input type="hidden" name="appReturnScheme" value="" />
          {/* IOS 에서 ISP 인증 취소후 이동될 가맹점 APP의 scheme 이름  */}
          <input type="hidden" name="appCancelScheme" value="" />
        </form>

        <Bottom pay={this.pay} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(PaymentPayStory);
